import styled, { css } from 'styled-components';
import { ColorAddiBlack, ColorAddiCompFiveLighten3, ColorAddiFontStrong, ColorAddiGrayLighten3, ColorAddiPrimaryActive, ColorAddiWhite, } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightMedium, FontAddiWeightRegular } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { Header3, Paragraph, SecondaryFont } from '../../typographies';
import { PrimaryButton, SecondaryButton } from '../../button';
import { MINIMUM_WIDTH_RESPOSIVENESS } from '../header-menu.styled';
const MenuButtonEscencials = css `
  width: auto;
  padding: 12px 15px !important;
  margin-right: 10px;
  min-width: 107px;
  font-size: ${SizeAddiFontXSmall};
`;
export const MobileMenu = styled.div `
  width: 100%;
  z-index: 10;
  height: 100%;
  overflow-y: scroll;
  display: block;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: none;
  }
`;
export const DektopMenu = styled.div `
  width: 100%;
  z-index: 10;
  height: 100%;
  display: none;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: block;
    li.first-level-li:first-child {
      > a:after {
        bottom: 7px;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 100%;
        width: 80%;
        background-color: ${ColorAddiBlack};
        margin: 0 auto;
        left: 0;
        right: 0;
      }
    }
  }
`;
export const InnerMenuHeader = styled.div `
  display: flex;
  cursor: pointer;
  align-items: center;
  height: 35px;
`;
export const HeaderInnerMenuBar = styled.div `
  display: ${({ showMenu }) => (showMenu ? 'flex' : 'none')};
  justify-content: space-between;
  padding: 22px;

  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: none;
  }
`;
export const MenuTitle = styled(Paragraph) `
  margin: 0;
  line-height: 26.64px;
`;
export const MenuBody = styled.div `
  height: 100%;
  margin: 0 20px;
`;
export const ParentName = styled(Header3) `
  font-size: ${SizeAddiFontSmall};
  font-weight: ${FontAddiWeightMedium};
  line-height: 14.84px;
  text-align: left;
`;
export const SubMenu = styled.ul `
  height: 60%;
  overflow: hidden;
  overflow-y: auto;
  float: none;
  list-style: none;
  margin: 0;
  padding: 0;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    height: auto;
    overflow: inherit;
  }
`;
export const MenuItemLink = styled.a `
  ${SecondaryFont}
  font-weight: ${FontAddiWeightRegular};
  font-size: ${SizeAddiFontXSmall};
  line-height: 18.48px;
  color: ${ColorAddiFontStrong};
  outline: none;

  text-decoration: none;
  text-transform: none;
  padding: 16.5px 0;
  box-shadow: inset 0px -1px 0px ${ColorAddiGrayLighten3};
  display: block;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: inline;
    padding: 10px 15px;
    z-index: 99;
    box-shadow: none;
    border-radius: 48px;
  }
`;
export const ImageFlag = styled.img `
  max-width: 20px;
  display: inline-block;
  border-style: none;
  padding-right: 12px;
  vertical-align: middle;
`;
export const HeaderButtonsContainer = styled.div `
  display: flex;
  justify-content: end;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;

  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    flex-direction: row;
    padding: 0;
  }
`;
export const PayButton = styled(SecondaryButton) `
  ${MenuButtonEscencials}
  margin-bottom: 18px;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    margin-bottom: 0;
  }
`;
export const LogInButton = styled(PrimaryButton) `
${MenuButtonEscencials}
border: 2px solid ${ColorAddiPrimaryActive} !important;
margin-bottom: 20px;
@media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    margin-bottom: 0;
    position: absolute;
    top: 4%;
  }
`;
export const HasSubmenuIcon = styled.img `
  float: right;
  width: 10px;
  margin-top: 2%;
  margin-right: 25px;
  transform: ${({ rotateIcon }) => (rotateIcon ? 'rotate(-180deg)' : 'none')};
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    top: -2px;
    left: 4px;
    right: auto;
    transform: none;
    position: relative;
    float: none;
    margin: 0;
  }
`;
export const GoBackIcon = styled.img `
  margin-right: 16px;
`;
export const CloseIcon = styled.img `
  cursor: pointer;
`;
export const MenuItemSubMenu = styled.ul `
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: center;
  background-color: ${ColorAddiWhite};
  display: none;
  flex-direction: column;
  display: ${({ showMobile }) => (showMobile ? 'block' : 'none')};
  padding-left: 25px;
  box-shadow: none;
  border-radius: 0;
  border: 0;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    box-shadow: 0 23px 50px -14px rgba(0, 0, 0, 0.21);
    border: 2px solid ${ColorAddiGrayLighten3};
    border-radius: 0px 0px 16px 16px;
    z-index: -1;
    top: 50%;
    padding: 0;
    padding-top: 11%;
    margin: 0;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
  }
`;
export const MenuSubItemLink = styled(MenuItemLink) `
  display: block;
  padding: 16.5px 0;
  :hover {
    text-decoration: underline;
  }
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    padding: 10px;
  }
`;
export const MenuItem = styled.li `
  font-size: 18px;
  position: relative;
  display: block;
  text-align: left;

  cursor: pointer;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: ${({ isBr }) => (isBr ? 'flex' : 'inline-block')};
    padding: ${({ noPadding }) => (noPadding ? '0' : '8px 0')};
    margin: 0;
    box-shadow: none;
    width: auto;
    border-radius: 48px;
    :hover {
      ${MenuItemSubMenu} {
        display: flex;
      }
      > ${MenuItemLink} {
        color: ${ColorAddiBlack};
        background-color: ${ColorAddiCompFiveLighten3};
        > img {
          transform: rotate(-180deg);
        }
      }
      && > ${MenuSubItemLink} {
        background-color: transparent;
      }
    }
  }
`;
export const LogoContainer = styled.div `
  max-width: 250px;
  height: 35px;
  cursor: pointer;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    margin-right: 20px;
  }
`;
export const LogoImage = styled.img `
  width: 85px;
  border-width: 0;
  border: 0;
`;
export const HideOnMobile = styled.div `
  display: none;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: block;
  }
`;
//# sourceMappingURL=header-menu-components.styled.js.map